import BaseComponent from "components/base-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default class ComponentsEmailTemplatesLink extends BaseComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    emailTemplate: instanceOfClassName("EmailTemplate").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, emailTemplate, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--email-templates--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || emailTemplate.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || emailTemplate.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, emailTemplate} = this.p

    if (adminLayout) return Routes.adminEmailTemplatePath(emailTemplate.id())
  }
}
